import React from 'react';

import { Box, Skeleton, Stack } from '@rbilabs/universal-components';

import { Section } from 'components/features/components/marketing-tile-group/styled';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { WEB_APP_MAX_WIDTH } from 'utils/constants';

import { ButtonContainer } from './styles';
import { Direction, HorizontalPosition } from './types';

const Container = Box.withConfig({
  marginTop: '$3',
});

const SkeletonButton = ButtonContainer.withConfig({
  marginTop: '30px',
});

const MarketingTileWrapper = ({ width }: { width: string }) => (
  <Box width={width} bg={Styles.color.cardBackground} borderRadius={16} mb={{ md: '$4' }}>
    <Skeleton h="$24" borderTopRadius={16} />
    <Box padding="$2.5">
      <Skeleton.Text
        lines={2}
        _line={{
          height: '20px',
        }}
      />
      <SkeletonButton
        isShowingTwoButtons={false}
        $direction={Direction.DEFAULT}
        buttonPosition={HorizontalPosition.RIGHT}
      >
        <Skeleton height="30px" width="135px" rounded="2xl" />
      </SkeletonButton>
    </Box>
  </Box>
);

export const MarketingTileSkeleton = () => {
  const isMobile = useIsMobileBreakpoint();
  const width = isMobile ? 'full' : `${WEB_APP_MAX_WIDTH / 2 - 32}px`;

  if (isMobile) {
    return (
      <Container>
        <Section>
          <MarketingTileWrapper width={width} />
        </Section>
        <Section>
          <MarketingTileWrapper width={width} />
        </Section>
      </Container>
    );
  }

  return (
    <Stack
      testID="marketing-tile-skeleton-loader"
      space={4}
      marginX={4}
      direction="row"
      flexWrap="wrap"
      mt="$8"
    >
      <MarketingTileWrapper width={width} />
      <MarketingTileWrapper width={width} />
      <MarketingTileWrapper width={width} />
      <MarketingTileWrapper width={width} />
    </Stack>
  );
};
